import {
    FETCH_SCHEMASELECTION_FAILURE,
    FETCH_SCHEMASELECTION_REQUEST,
    FETCH_SCHEMASELECTION_SUCCESS
} from "./actionTypes";
import {
    FetchSchemaSelectionRequest,
    FetchSchemaSelectionSuccess,
    FetchSchemaSelectionSuccessPayload,
    FetchSchemaSelectionFailure,
    FetchSchemaSelectionFailurePayload,
} from "./types";

export const fetchSchemaSelectionRequest = (params: number): FetchSchemaSelectionRequest => ({
    type: FETCH_SCHEMASELECTION_REQUEST,
    params: params
});

export const fetchSchemaSelectionSuccess = (
    payload: FetchSchemaSelectionSuccessPayload
): FetchSchemaSelectionSuccess => ({
    type: FETCH_SCHEMASELECTION_SUCCESS,
    payload,
});

export const fetchSchemaSelectionFailure = (
    payload: FetchSchemaSelectionFailurePayload
): FetchSchemaSelectionFailure => ({
    type: FETCH_SCHEMASELECTION_FAILURE,
    payload,
});